import { ScriptStep } from '@/constants'

export type WitnessStepPolicies = {
  canHaveCna: boolean
  isExaminationUnderOath: boolean
  shouldConfirmStipulations: boolean
}

export const getWitnessStepPolicySkip = (
  stepKey: ScriptStep,
  actionKey: string,
  policies: WitnessStepPolicies,
): boolean | undefined => {
  if (stepKey === ScriptStep.ATTENDANCE && actionKey === 'cna') {
    return !policies.canHaveCna
  }

  if (stepKey !== ScriptStep.CLOSING) {
    return undefined
  }

  // The read/waive step is shown for every deposition, whether or not the
  // question is asked: where the jurisdiction decides, the answer field is
  // replaced by an instruction and the reporter still confirms the step.
  if (
    actionKey === 'confirm_read_or_waive' ||
    actionKey === 'collect_transcript_orders' ||
    actionKey === 'confirm_orders' ||
    actionKey === 'select_errata_recipient'
  ) {
    return policies.isExaminationUnderOath
  }

  if (actionKey === 'confirm_stipulations') {
    return !policies.shouldConfirmStipulations
  }

  return undefined
}
